const pageSelector = (newPage) => {
    return dispatch => {
        dispatch({type: 'SELECT_PAGE', currentPage: newPage});
    }
}
export { pageSelector }